// removed by extract-text-webpack-plugin
module.exports = {"Container":"Container__1hoWw","CategoriesWrapper":"CategoriesWrapper__3Hwdw","RowFocused":"RowFocused__3Ts8Y","Row":"Row__OmAJI","QuestionsContainer":"QuestionsContainer__sXK8r"};


//////////////////
// WEBPACK FOOTER
// ./routes/HelpDesk/style.scss
// module id = K3CK
// module chunks = 0